<template>
  <el-dialog
    title="师傅统计和异常详情"
    :visible.sync="dialogVisible"
    width="90%"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div style="margin-bottom: 20px;">
      <h3 style="margin-bottom: 10px;">师傅统计</h3>
      <BaseTable
        :tableData="installerStatisticsData"
        :columns="installerStatisticsColumns"
        :showPagination="false"
        :showOperationColumn="true"
        :row-class-name="getRowClassName"
        :max-height="400"
      >
        <template #abnormalCount="{ row }">
          <span :style="row.abnormalCount > 0 ? 'color: #f56c6c; font-weight: bold;' : ''">
            {{ row.abnormalCount }}
          </span>
        </template>
        <template #abnormalRatePercent="{ row }">
          <span :style="row.abnormalRatePercent != null && row.abnormalRatePercent > 0 ? 'color: #f56c6c; font-weight: bold;' : ''">
            {{ row.abnormalRatePercent != null ? `${row.abnormalRatePercent}%` : "-" }}
          </span>
        </template>
        <template #operation="{ row }">
          <el-button
            type="primary"
            size="mini"
            @click="handleViewDetails(row)"
          >
            查看异常详细
          </el-button>
        </template>
      </BaseTable>
    </div>
    <div>
      <h3 style="margin-bottom: 10px;">异常详细（{{ currentInstallerName || '请选择师傅' }}）</h3>
      <div style="overflow-x: auto;">
        <BaseTable
          :tableData="abnormalDetailsData"
          :columns="abnormalDetailsColumns"
          :showPagination="false"
          :showOperationColumn="false"
          :max-height="400"
        >
          <template #originalLineLength="{ row }">
            <span :style="isLineLengthDifferent(row) ? 'color: #f56c6c; font-weight: bold;' : ''">
              {{ row.originalLineLength != null ? row.originalLineLength : "-" }}
            </span>
          </template>
          <template #addOutlay="{ row }">
            <span>
              {{ row.addOutlay != null && row.addOutlay != 0 ? row.addOutlay : "-" }}
            </span>
          </template>
          <template #originalAddOutlay="{ row }">
            <span :style="isAddOutlayDifferent(row) ? 'color: #f56c6c; font-weight: bold;' : ''">
              {{ row.originalAddOutlay != null && row.originalAddOutlay != 0 ? row.originalAddOutlay : "-" }}
            </span>
          </template>
          <template #syncCompleteTime="{ row }">
            {{ formatTime(row.syncCompleteTime) }}
          </template>
        </BaseTable>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import BaseTable from "@/components/BaseTable";
import moment from "moment";

export default {
  name: "InstallerStatisticsDialog",
  components: {
    BaseTable,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    settlementBatchName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      installerStatisticsData: [],
      abnormalDetailsData: [],
      currentInstallerName: "",
      selectedInstallerId: null,
      installerStatisticsColumns: [
        {
          prop: "installerName",
          label: "安装师傅",
        },
        {
          prop: "totalCount",
          label: "订单数",
        },
        {
          prop: "abnormalCount",
          label: "异常数",
          slot: "abnormalCount",
        },
        {
          prop: "abnormalRatePercent",
          label: "异常占比",
          slot: "abnormalRatePercent",
        },
      ],
      abnormalDetailsColumns: [
        {
          prop: "brandName",
          label: "品牌",
        },
        {
          prop: "carModelName",
          label: "车型",
        },
        {
          prop: "vin",
          label: "车架号",
        },
        {
          prop: "companyName",
          label: "所属公司",
        },
        {
          prop: "mainOrderNo",
          label: "主机订单号",
        },
        {
          prop: "upstreamOrderNo",
          label: "上游订单号",
        },
        {
          prop: "customerName",
          label: "客户名称",
        },
        {
          prop: "contactInfo",
          label: "联系方式",
        },
        {
          prop: "installerName",
          label: "安装师傅",
        },
        {
          prop: "lineLength",
          label: "用线长度（同步后）",
        },
        {
          prop: "addOutlay",
          label: "增项费用（同步后）",
          slot: "addOutlay",
        },
        {
          prop: "originalLineLength",
          label: "用线长度（同步前）",
          slot: "originalLineLength",
        },
        {
          prop: "originalAddOutlay",
          label: "前增项费用（同步前）",
          slot: "originalAddOutlay",
        },
        {
          prop: "syncCompleteTime",
          label: "同步完成时间",
          slot: "syncCompleteTime",
        },
      ],
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  watch: {
    visible(newVal) {
      if (newVal && this.settlementBatchName) {
        this.loadInstallerStatistics();
        this.abnormalDetailsData = [];
        this.currentInstallerName = "";
      }
    },
    settlementBatchName(newVal) {
      if (newVal && this.visible) {
        this.loadInstallerStatistics();
        this.abnormalDetailsData = [];
        this.currentInstallerName = "";
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
      this.installerStatisticsData = [];
      this.abnormalDetailsData = [];
      this.currentInstallerName = "";
      this.selectedInstallerId = null;
    },
    loadInstallerStatistics() {
      if (!this.settlementBatchName) {
        return;
      }
      this.axios({
        url: `/pending-settlement-order/add-sync-record/installer-statistics?settlementBatchName=${this.settlementBatchName}`,
        method: "get",
      }).then((res) => {
        if (res.data.code == 200) {
          this.installerStatisticsData = res.data.data || [];
          // 默认加载第一个师傅的异常详细数据
          if (this.installerStatisticsData.length > 0) {
            const firstInstaller = this.installerStatisticsData[0];
            this.selectedInstallerId = firstInstaller.installerId;
            this.handleViewDetails(firstInstaller);
          }
        } else {
          this.$message.error(res.data.message || "获取师傅统计失败");
        }
      });
    },
    handleViewDetails(row) {
      if (!this.settlementBatchName || !row.installerId) {
        return;
      }
      // 更新选中的师傅ID和名称
      this.selectedInstallerId = row.installerId;
      this.currentInstallerName = row.installerName || "";
      this.axios({
        url: `/pending-settlement-order/add-sync-record/abnormal-details?settlementBatchName=${this.settlementBatchName}&installerId=${row.installerId}`,
        method: "get",
      }).then((res) => {
        if (res.data.code == 200) {
          this.abnormalDetailsData = res.data.data || [];
        } else {
          this.$message.error(res.data.message || "获取异常详细失败");
        }
      });
    },
    getRowClassName({ row }) {
      if (this.selectedInstallerId && row.installerId === this.selectedInstallerId) {
        return "selected-row";
      }
      return "";
    },
    formatTime(time) {
      if (!time) {
        return "-";
      }
      return moment(time).format("YYYY-MM-DD HH:mm:ss");
    },
    /**
     * 判断值是否有效（非空且非零）
     * @param {*} value 要判断的值
     * @returns {boolean} 如果值有效返回true，否则返回false
     */
    isValidValue(value) {
      // 处理 null、undefined、空字符串
      if (value == null || value === '') {
        return false;
      }
      // 转换为数字
      const num = parseFloat(value);
      // 如果转换失败或为NaN，视为无效
      if (isNaN(num)) {
        return false;
      }
      // 如果为0，也视为无效（因为0和null/空字符串表示相同含义：没有值）
      return num !== 0;
    },
    /**
     * 获取有效的数值（将null、undefined、空字符串、0都转换为0）
     * @param {*} value 要转换的值
     * @returns {number} 转换后的数值
     */
    getValidNumber(value) {
      if (value == null || value === '') {
        return 0;
      }
      const num = parseFloat(value);
      return isNaN(num) ? 0 : num;
    },
    /**
     * 判断用线长度是否有差异
     * @param {Object} row 行数据
     * @returns {boolean} 如果有差异返回true，否则返回false
     */
    isLineLengthDifferent(row) {
      const original = this.getValidNumber(row.originalLineLength);
      const current = this.getValidNumber(row.lineLength);
      
      // 如果两个值都无效（都是0/null/空），则认为相同
      if (!this.isValidValue(original) && !this.isValidValue(current)) {
        return false;
      }
      
      // 如果只有一个值有效，则认为不同
      if (this.isValidValue(original) !== this.isValidValue(current)) {
        return true;
      }
      
      // 如果两个值都有效，比较数值差异
      return Math.abs(original - current) > 0.01;
    },
    /**
     * 判断增项费用是否有差异
     * @param {Object} row 行数据
     * @returns {boolean} 如果有差异返回true，否则返回false
     */
    isAddOutlayDifferent(row) {
      const original = this.getValidNumber(row.originalAddOutlay);
      const current = this.getValidNumber(row.addOutlay);
      
      // 如果两个值都无效（都是0/null/空），则认为相同
      if (!this.isValidValue(original) && !this.isValidValue(current)) {
        return false;
      }
      
      // 如果只有一个值有效，则认为不同
      if (this.isValidValue(original) !== this.isValidValue(current)) {
        return true;
      }
      
      // 如果两个值都有效，比较数值差异（增项费用使用0.01的精度）
      return Math.abs(original - current) > 0.01;
    },
  },
};
</script>

<style scoped>
/* 选中行样式 */
::v-deep .el-table .selected-row {
  background-color: #f5f7fa !important;
}


::v-deep .el-table .selected-row td {
  background-color: transparent !important;
}
</style>

